import React, { useMemo, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import { isThirdPartyTypeSupported } from '../../utils/activateUtr';
import { authenticateActivateUtrToken } from '../../actions/activate-utr-actions';

export default (ChildComponent) => {
    const ParentComponent = (props) => {
        const { location, activateUtr, authenticateToken } = props;

        const [canLoadChild, setCanLoadChild] = useState(false);

        const queryParams = useMemo(() => {
            return queryString.parse(location.search) || {};
        }, [location.search]);

        useEffect(() => {
            const checkTypeAndAuthenticate = async () => {
                const isFromActivateUtrFlow = queryParams.activationType && queryParams.activationToken;
                if (isFromActivateUtrFlow && isThirdPartyTypeSupported(queryParams.activationType) && !activateUtr?.user) {
                    await authenticateToken({
                        token: queryParams.activationToken,
                        type: queryParams.activationType,
                    });
                } else {
                    setCanLoadChild(true);
                }
            };

            checkTypeAndAuthenticate();
        }, [queryParams, authenticateToken, activateUtr.user]);

        if (canLoadChild) {
            return (
                <ChildComponent
                    {...props}
                    activateUtr={activateUtr}
                />
            );
        }

        return null;
    };

    function mapStateToProps({ activateUtr }) {
        return { activateUtr };
    }

    function mapDispatchToProps(dispatch) {
        return {
            authenticateToken: (data) => {
                dispatch(authenticateActivateUtrToken(data));
            },
        };
    }

    return connect(mapStateToProps, mapDispatchToProps)(ParentComponent);
};
